import React from "react";
import PropTypes from "prop-types";
import "../Button.scss";

/**
 * Universal <button> component as a React functional component.
 *
 * @param id
 * @param type
 * @param {string[]} classes - Array of CSS class names.
 * @param {string} text - Text displayed on the button.
 * @param {boolean} disabled - Disables the button if true.
 * @param hasIcon - Check if the button has an icon.
 * @param iconClasses - Array of CSS classes for the icon.
 * @param onClick - Function to handle click events.
 * @returns {JSX.Element}
 */
const Button = ({   id = "",
                    type = "button",
                    classes = [],
                    text,
                    disabled = false,
                    hasIcon = false,
                    iconClasses = [],
                    onClick, // Handles button click events
                }) => {
    // Combine classes into a single string
    const className = classes.join(" ");

    return (
        <button
            id={id}
            type={type}
            className={className}
            onClick={onClick}
            disabled={disabled} // Handles the disabled state
        >
            {hasIcon && <span className={`btn-icon ${iconClasses.join(" ")}`}></span>}
            {text}
        </button>
    );
};

Button.propTypes = {
    id: PropTypes.string,
    type: PropTypes.string.isRequired,
    classes: PropTypes.arrayOf(PropTypes.string), // Array of CSS class names
    text: PropTypes.string.isRequired,          // Text displayed on the button
    disabled: PropTypes.bool,                   // Disable button if true
    hasIcon: PropTypes.bool,                    // Check if the button has an icon
    iconClasses: PropTypes.arrayOf(PropTypes.string), // Array of CSS classes for the icon
    onClick: PropTypes.func,                    // Function to handle click events
};

export default Button;
